var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 12.5A4.5 4.5 0 0 1 5.5 8h4a.5.5 0 0 1 0 1h-4a3.5 3.5 0 1 0 0 7h4a.5.5 0 0 1 0 1h-4A4.5 4.5 0 0 1 1 12.5m5 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5M18.5 8a4.5 4.5 0 1 1 0 9h-4a.5.5 0 0 1 0-1h4a3.5 3.5 0 1 0 0-7h-4a.5.5 0 0 1 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgLink = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDEyLjVDMSAxMC4wMTQ3IDMuMDE0NzIgOCA1LjUgOEw5LjUgOEM5Ljc3NjE0IDggMTAgOC4yMjM4NiAxMCA4LjVDMTAgOC43NzYxNCA5Ljc3NjE0IDkgOS41IDlINS41QzMuNTY3IDkgMiAxMC41NjcgMiAxMi41QzIgMTQuNDMzIDMuNTY3IDE2IDUuNSAxNkg5LjVDOS43NzYxNCAxNiAxMCAxNi4yMjM5IDEwIDE2LjVDMTAgMTYuNzc2MSA5Ljc3NjE0IDE3IDkuNSAxN0g1LjVDMy4wMTQ3MiAxNyAxIDE0Ljk4NTMgMSAxMi41Wk02IDEyLjVDNiAxMi4yMjM5IDYuMjIzODYgMTIgNi41IDEySDE3LjVDMTcuNzc2MSAxMiAxOCAxMi4yMjM5IDE4IDEyLjVDMTggMTIuNzc2MSAxNy43NzYxIDEzIDE3LjUgMTNINi41QzYuMjIzODYgMTMgNiAxMi43NzYxIDYgMTIuNVpNMTguNSA4QzIwLjk4NTMgOCAyMyAxMC4wMTQ3IDIzIDEyLjVDMjMgMTQuOTg1MyAyMC45ODUzIDE3IDE4LjUgMTdIMTQuNUMxNC4yMjM5IDE3IDE0IDE2Ljc3NjEgMTQgMTYuNUMxNCAxNi4yMjM5IDE0LjIyMzkgMTYgMTQuNSAxNkgxOC41QzIwLjQzMyAxNiAyMiAxNC40MzMgMjIgMTIuNUMyMiAxMC41NjcgMjAuNDMzIDkgMTguNSA5TDE0LjUgOUMxNC4yMjM5IDkgMTQgOC43NzYxNCAxNCA4LjVDMTQgOC4yMjM4NiAxNC4yMjM5IDggMTQuNSA4SDE4LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";